{
  "labels": {
    "trenutni": "Firma attuale:",
    "alt": "Non hai ancora aggiunto una firma!",
    "buttons": {
      "dodaj": "Aggiungi / Sostituisci la tua firma",
      "shrani": "Salva",
      "pocisti": "Cancella"
    }
  }
}